export { COGNITO_POOLS, getCognitoConfig } from './cognito/config';
export type { ApiEnv, CognitoPoolConfig } from './cognito/config';

export { fetchRefreshedTokens } from './cognito/refreshTokens';
export type {
  CognitoRefreshResponse,
  RefreshTokensResult,
} from './cognito/refreshTokens';

export {
  STORAGE_KEYS,
  COOKIE_NAMES,
  LEGACY_COOKIE_NAMES,
  SSO_COOKIE_DOMAIN,
  getSsoCookieNames,
  normalizeApiEnv,
} from './tokens/constants';

export {
  getTokens,
  getRefreshToken,
  setTokens,
  removeTokens,
  removeAccessAndIdTokens,
} from './tokens/localStorage';
export type { TokenSet } from './tokens/localStorage';

export {
  readSsoCookies,
  writeSsoCookies,
  clearSsoCookies,
} from './tokens/cookies';
export type { SsoCookieTokens } from './tokens/cookies';

export {
  decodeToken,
  isTokenExpired,
  isAccessTokenValid,
  isIdTokenExpired,
} from './session/decode';
export type { DecodedToken } from './session/decode';

export { canMakeAuthenticatedRequests } from './session/canMakeAuthenticatedRequests';
export { getSessionReadyFromSso } from './session/getSessionReadyFromSso';

export {
  authHeader,
  getAuthHeadersWithBearer,
  getAuthHeadersWithTokenOnly,
} from './session/apiHeaders';
export type { AuthHeaders } from './session/apiHeaders';

export {
  SsoProvider,
  useSso,
  useSsoOptional,
} from './sso/providers/SsoProvider';
export type { SsoProviderProps } from './sso/providers/SsoProvider';
export type {
  SsoContextValue,
  SessionPhase,
  SessionLockCopy,
} from './sso/types';

export { AUTH_EVENTS } from './sso/constants/events';
export type { AuthEventName } from './sso/constants/events';

export { TOKEN_REFRESH_BUFFER_MS } from './sso/utils/tokenRefreshSchedule';

export { default as withSSO } from './sso/hoc/withSSO';
export { default } from './sso/hoc/withSSO';
export type { SsoConfig, SsoInjectedProps } from './sso/types';
